import { hideLoading } from '@/common/functions/loading';
import Home from '@/spa/Home';
import Landing from '@/spa/Landing';
import NotFound from '@/spa/NotFound';
import SilentCheckSso from '@/spa/SilentCheckSso';
import alertaManutencao from './administracao/alerta-manutencao';
import calendario from './administracao/calendario';
import estruturaUsuario from './administracao/estrutura-usuario';
import dashboardInicial from './dashboard-inicial';
import filial from './administracao/filial';
import divisao from './administracao/divisao';
import ssoGrupo from './administracao/sso-grupo';
import usuarioFuncionario from './administracao/usuario-funcionario';
import usuarioFornecedor from './administracao/usuario-fornecedor';
import usuarioFornecedorNovo from './administracao/usuario-fornecedor-novo';
import unidadeMedida from './cadastro/unidade-medida';
import regiao from './administracao/regiao';
import workflow from './administracao/workflow';
import termoAceite from './administracao/termo-aceite';
import tipoUso from './tipo-uso';
import produto from './cadastro/produto';
import nivelFornecedor from './administracao/nivel-fornecedor';
import importacao from './importacoes';
import fornecedor from './cadastro/fornecedor';
import notas from './cadastro/notas';
import planejamentoAcao from './acao/planejamento-acao';
import apuracaoAcao from './acao/apuracao-acao';
import recebimento from './acao/recebimento';
import planejamentoContrato from './contrato/planejamento-contrato';
import apuracaoContrato from './contrato/apuracao-contrato';
import apuracaoContratoSamsung from './contrato/apuracao-contrato-samsung';
import apuracaoContratoEpoca from './contrato/apuracao-contrato-epoca';
import parametrizacaoAcao from './parametrizacao/parametrizacao-acao';
import notasDebitoContabilizacao from './notas-debito/notas-debito-contabilizacao';
import notasDebitoConsulta from './notas-debito/notas-debito-consulta';
import relatorios from './relatorios';
import camposCustomizados from './parametrizacao/campos-customizados';
import nivelProduto from './parametrizacao/nivel-produto';
import parametrizacaoContrato from './parametrizacao/parametrizacao-contrato';
import configuracaoSistema from './parametrizacao/configuracao-sistema';
import administracao from './administracao/administracao';
import representacaoConjunto from './administracao/representacao-conjunto';
import role from './administracao/role';

const ACCESS_TOKEN_KEY = 'id_magalu_access_token';
const REFRESH_TOKEN_KEY = 'id_magalu_refresh_token';

const configureGuards = (router) => {
  router.afterEach((route) => {
    if (route.params.menu) {
      hideLoading();
    }
  });
  router.beforeEach((to, from, next) => {
    if (to.matched.some((r) => r.meta.requiresAuth)) {
      const token = sessionStorage.getItem('token') || sessionStorage.getItem(ACCESS_TOKEN_KEY)
        || localStorage.getItem(REFRESH_TOKEN_KEY);
      if (!token && !window.location.href.includes('code=')) {
        next('/');
        return;
      }
    }
    next();
  });
};

export const routes = [
  {
    path: '/',
    name: 'landing',
    component: Landing,
  },
  {
    path: '/silentCheckSso',
    name: 'silentCheckSso',
    component: SilentCheckSso,
  },
  {
    path: '/app',
    component: Home,
    children: [
      {
        path: '',
        redirect: { name: 'inicio' },
      },
      {
        ...dashboardInicial,
        name: 'inicio',
      },
      alertaManutencao,
      importacao,
      calendario,
      divisao,
      estruturaUsuario,
      filial,
      regiao,
      ssoGrupo,
      tipoUso,
      termoAceite,
      unidadeMedida,
      usuarioFuncionario,
      usuarioFornecedor,
      usuarioFornecedorNovo,
      workflow,
      produto,
      nivelFornecedor,
      fornecedor,
      notas,
      planejamentoAcao,
      apuracaoAcao,
      recebimento,
      planejamentoContrato,
      apuracaoContrato,
      apuracaoContratoSamsung,
      apuracaoContratoEpoca,
      notasDebitoContabilizacao,
      notasDebitoConsulta,
      relatorios,
      camposCustomizados,
      nivelProduto,
      parametrizacaoAcao,
      parametrizacaoContrato,
      configuracaoSistema,
      administracao,
      representacaoConjunto,
      role,
    ],
  },
  {
    path: '*',
    component: NotFound,
  },
];

export const VueRouterObject = {
  routes,
  saveScrollPosition: true,
};

export default (VueRouter) => {
  const vueRouter = new VueRouter(VueRouterObject);
  configureGuards(vueRouter);
  return vueRouter;
};
